import { useAuth0 } from "@auth0/auth0-react";
import { ThemeProvider } from "@mui/material";
import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import { Association } from "./Auth0LoginSteps/components/association/association";
import ResetMFA from "./Auth0LoginSteps/components/mfa/resetmfa";
import ResetSuccessful from "./Auth0LoginSteps/components/mfa/resetsuccessful"
import ResetMFAVerification from "./Auth0LoginSteps/components/mfa/resetmfaverification";
import { PageLoader } from "./Auth0LoginSteps/components/association/page-loader";
import { ProtectedRoute } from "./Auth0LoginSteps/components/association/protected-route";
import emailsent from "./Auth0LoginSteps/components/mfa/emailsent";
import PhoneNumber from "./Auth0LoginSteps/components/passwordlessFlow/phoneNumber";
import VerificationCode from "./Auth0LoginSteps/components/passwordlessFlow/verificationCode";
import { TrustPicker } from "./Auth0LoginSteps/components/trustPicker/customerCodeSelector";
import { QueryProvider } from "./Auth0LoginSteps/context/query";
import theme from "./Auth0LoginSteps/styles/theme";
import LocalizationProvider from "./LocalizatonProvider";

const App: React.FC = () => {
    const { isLoading } = useAuth0();
    return (
        <QueryProvider>
            <LocalizationProvider>
                <ThemeProvider theme={theme}>
                    <div className="App">
                        <div className="cover">
                            <img className="cover-logo" src="https://www.rldatix.com/en-nam/wp-content/uploads/sites/4/2024/08/logo-light.svg" />
                        </div>
                        <div className="form-container">
                            <Switch>
                                <Route exact path="/phoneNumber" component={PhoneNumber} />
                                <Route exact path="/verification" component={VerificationCode} />
                                <Route exact path="/trustPicker" component={TrustPicker} />
                                <ProtectedRoute path="/reset-mfa" component={ResetMFA} />
                                <Route path="/reset-successful" component={ResetSuccessful} />
                                <Route path="/reset-mfa-verification" component={ResetMFAVerification} />
                                <ProtectedRoute path="/emailsent" component={emailsent} />
                                <ProtectedRoute path="/association" component={Association} />
                            </Switch>
                        </div>
                    </div>
                </ThemeProvider>
            </LocalizationProvider>
        </QueryProvider>
    );
};
export default App;
